//@flow
import type { ReducerState$Type } from '../genericFlowTypes'
import type { EditFormData } from '../phobos/flowTypes'

export const transformDataToEditFormData=(data:any,harmonia: ReducerState$Type)=>{
    let formData: EditFormData = {}
    
    const harmoniaResultsetData = data['harmoniaResultset']
    formData.isInvalidDoc = harmoniaResultsetData['is_invalid_doc']?harmoniaResultsetData['is_invalid_doc']:false
    formData.isOverrideVendorName = harmoniaResultsetData['is_override_vendor_name']?harmoniaResultsetData['is_override_vendor_name']:false
    formData.isOverrideTotal = harmoniaResultsetData['is_override_total']?harmoniaResultsetData['is_override_total']:false
    
    if (harmoniaResultsetData['inv_no']){
        formData.invNo = harmoniaResultsetData['inv_no']
    }
    if (harmoniaResultsetData['inv_date']){
        formData.invDate = harmoniaResultsetData['inv_date']
    }
    if (harmoniaResultsetData['service_addr']){
        formData.serviceAddr = harmoniaResultsetData['service_addr']
    }
    if (harmoniaResultsetData['total']){
        formData.total = parseFloat(harmoniaResultsetData['total'])
    }
    if (harmoniaResultsetData['vendor_name']){
        formData.vendorName = harmoniaResultsetData['vendor_name']
    }
    
    return formData
}


// WEBPACK FOOTER //
// ./src/redux/harmonia/editFormData.js